export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8771.1b748dc7.jpg";